import { GET_OUTGOING_TARGETS_WITH_PAGINATION } from '../types/outgoingTargetTypes';
import { ACCOUNT_LOGOUT } from '../types/accountTypes';

const outgoingTagertsReducer = (initialState = {}, action) => {
  switch (action.type) {
    case GET_OUTGOING_TARGETS_WITH_PAGINATION:
      return action.payload;
    case ACCOUNT_LOGOUT:
      return {
        outgoingTarget: [],
        pageNumber: 0,
        totalCount: undefined,
      };
    default:
      return initialState;
  }
};

export default outgoingTagertsReducer;
